import {match} from 'ts-pattern';

import {AdServer} from '../types/AdServer';

export const mapMarketToAdServer = (market: string): AdServer[] =>
  match(market)
    .with('CZE', () => [AdServer.SAUTO, AdServer.TIPCARS])
    .with('DEU', () => [AdServer.MOBILE_DE, AdServer.KLEINANZEIGEN])
    .with('POL', () => [AdServer.OTOMOTO, AdServer.AUTOSCOUT24])
    .with('AUT', () => [AdServer.AUTOSCOUT24, AdServer.MOBILE_DE])
    .with('ITA', () => [AdServer.AUTOSCOUT24])
    .with('SVK', () => [AdServer.AUTOBASAR, AdServer.TIPCARS])
    .with('FRA', () => [AdServer.LA_CENTRALE, AdServer.AUTOSCOUT24])
    .with('SWE', () => [AdServer.BLOCKET])
    .with('ROU', () => [AdServer.AUTOVIT])
    .with('BEL', () => [AdServer.AUTOSCOUT24, AdServer.TWODEHANDS, AdServer.VOLVO_SELEKT])
    .with('NLD', () => [AdServer.AUTOSCOUT24, AdServer.MARKTPLAATS])
    .with('LUX', () => [AdServer.LUXAUTO, AdServer.AUTOSCOUT24])
    .otherwise(() => [AdServer.MOBILE_DE]);
